import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorGrayLight1 } from 'styles/layout/colors';
const IconMobileGrid2x = t0 => {
  const $ = _c(9);
  let otherProps;
  let t1;
  if ($[0] !== t0) {
    ({
      color: t1,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
  } else {
    otherProps = $[1];
    t1 = $[2];
  }
  const color = t1 === undefined ? colorGrayLight1 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g transform="translate(331.000000, 164.000000)"><path d="M0.625,12.375 L12.375,12.375 L12.375,0.625 L0.625,0.625 L0.625,12.375 Z" /><path d="M0.625,28.375 L12.375,28.375 L12.375,16.625 L0.625,16.625 L0.625,28.375 Z" /><path d="M16.625,12.375 L28.375,12.375 L28.375,0.625 L16.625,0.625 L16.625,12.375 Z" /><path d="M16.625,28.375 L28.375,28.375 L28.375,16.625 L16.625,16.625 L16.625,28.375 Z" /></g>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== color) {
    t3 = <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g transform="translate(-331.000000, -164.000000)" stroke={color} strokeWidth="1.25">{t2}</g></g>;
    $[4] = color;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== otherProps || $[7] !== t3) {
    t4 = <svg width="29px" height="29px" viewBox="0 0 29 29" {...otherProps}>{t3}</svg>;
    $[6] = otherProps;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
IconMobileGrid2x.propTypes = {
  color: PropTypes.string
};
export default IconMobileGrid2x;